/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/
import { Component, OnInit } from '@angular/core';
import { UIMessageService } from '../shared/services/uimessages.service';
import { UIMessagesResponse } from '../shared/model/uimessagesresponse';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomerPreferenceService } from '../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from './../../preference/customerpreference.model';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'zsd-newrequest',
  templateUrl: './newrequest.component.html',
  styleUrls: ['./newrequest.component.scss']
})
export class NewRequestComponent implements OnInit {
  uiMessageListResults: Array<UIMessagesResponse> = [];
  incidentMessage: string;
  serviceRequestMessage: string;
  changeRequestMessage: string;
  canCreateIncidents;
  canCreateServiceRequests;
  canCreateChangeRequests;
  customCategory;
  clearForm;
  fromNewRequest = true;
  fromItem;
  fromService;
  itemId;
  popupHeaderString;
  imagePath;
  showQuickCall;


  constructor(public uiMessageService: UIMessageService,
    public _DomSanitizer: DomSanitizer,
    public customerPreferenceService: CustomerPreferenceService, private route: ActivatedRoute,
    public router: Router) {
     this.router.events.subscribe(
      () => {
        if (this.router.url.includes('processIndexName')) {
          this.fromNewRequest = false;
        }
        if (this.router.url.includes('item')) {
          this.fromItem = true;
        }
        if (this.router.url.includes('sitem')) {
          this.fromService = true;
        }
      });
    }

  ngOnInit() {
    if (!this.fromNewRequest) {
      this.route.queryParams.subscribe(params => {
        if (params['processIndexName']) {
          this.customCategory = params['processIndexName'];
          this.localizeHeaderString();
        }
        if (params['itemId']) {
          this.itemId = params['itemId'];
        }
      });
      $('#zsd_modal_new_request').modal('show');
    }
    /* getting the customizable strings from admin portal and setting to the card */
    this.uiMessageService.getUIMessagesList().subscribe(
      (uimessages: UIMessagesResponse[]) => {
        this.uiMessageListResults = uimessages;
        for (let i = 0; i < this.uiMessageListResults.length; i++) {
          if (this.uiMessageListResults[i].name === 'IncidentLegend') {
            this.incidentMessage = this.uiMessageListResults[i].content;
          }
          if (this.uiMessageListResults[i].name === 'ServiceRequestLegend') {
            this.serviceRequestMessage = this.uiMessageListResults[i].content;
          }
          if (this.uiMessageListResults[i].name === 'ChangeRequestLegend') {
            this.changeRequestMessage = this.uiMessageListResults[i].content;
          }
        }
      },
      err => console.error(err)
    );
    // privilege check to show create option
    this.customerPreferenceService
      .getPreferenceList()
      .subscribe((preference: CustomerPreferenceResponse) => {
        this.canCreateIncidents = preference.canCreateIncidents;
        this.canCreateChangeRequests = preference.canCreateChangeRequests;
        this.canCreateServiceRequests = preference.canCreateServiceRequests;
        this.showQuickCall = preference.showQuickCall;
      },
      err => console.error(err)
      );
  }

  showCreateRequestPage(customCategory: string) {
    this.customCategory = customCategory;
    this.localizeHeaderString();
    $('#zsd_modal_new_request .modal-header').css('display', 'inline-flex');
    $('#zsd_modal_new_request .modal-header').show();
    $('#zsd_modal_new_request').css('width', '100%');
    $('#zsd_modal_new_request').css('margin-left', '0');
    $('#zsd_modal_new_request .modal').css('display', 'block');
    $('#request_success_msg').hide();
    $('#report_incident_row').show();
  }

  resetCreateRequest() {
    this.customCategory = '';
  }


  localizeHeaderString() {
    if (this.customCategory === 'incident') {
      this.popupHeaderString = 'NewRequest.incidentHeader';
      this.imagePath = 'img/createincidentheader.png';
    }
    if (this.customCategory === 'change') {
      this.popupHeaderString = 'NewRequest.changeRequestHeader';
      this.imagePath = 'img/createchangerequestheader.png';
    }
    if (this.customCategory === 'service') {
      this.popupHeaderString = 'NewRequest.serviceRequestHeader';
      this.imagePath = 'img/createservicerequestheader.png';
    }
  }
}
